module.exports = __webpack_public_path__ + "static/media/logo_terpel.3cdc80ac.jpg";